import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Point of Contact Profile",
  sections: [
    {
      name: "Point of Contact - Name & Title",
      fields: [
        {
          machine_name: "poc_emp_last_name",
          widget: "text",
          label: "Contact's Last (family) Name",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the last name of the individual employer, joint employer, job contractor, partnership, corporation, i.e. the employer filing this application.  The employer’s full legal business name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).",
        },
        {
          machine_name: "poc_emp_first_name",
          widget: "text",
          label: "First (given) Name",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the first name of the individual employer, joint employer, job contractor, partnership, corporation, i.e. the employer filing this application.  The employer’s full legal business name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).",
        },
        {
          machine_name: "poc_emp_middle_name",
          widget: "text",
          label: "Middle (given) Name",
          maxLength: 35,
          tooltip:
            "Enter the first name of the individual employer, joint employer, job contractor, partnership, corporation, i.e. the employer filing this application.  The employer’s full legal business name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).",
        },
        {
          machine_name: "poc_emp_job_title",
          widget: "text",
          label: "Job Title",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter the first trade name or 'Doing Business As' (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application.",
        },
      ],
    },
    {
      name: "Point of Contact - Address",
      fields: [
        {
          machine_name: "poc_emp_address1",
          widget: "text",
          label: "Address 1",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter the business street address for the employer.  The address must be a physical location and not a separate P.O. Box.  Since the addressing in the CNMI does not always follow the same entry format, see the Address Note for CNMI at the end of these general instructions.",
        },
        {
          machine_name: "poc_emp_address2",
          widget: "text",
          label: "Address 2",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this data field to complete the employer's street address.",
        },
        {
          machine_name: "poc_emp_city",
          widget: "text",
          label: "City",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the city of the employer's principal place of business.",
        },
        {
          machine_name: "poc_emp_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["poc_emp_state_id"],
          validate: ["required"],
          tooltip:
            "Enter the country of the employer’s principal place of business.",
        },
        {
          machine_name: "poc_emp_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          isVisible: {
            when: "poc_emp_country_id",
            is: "UNITED STATES OF AMERICA",
          },
          validate: ["required"],
          tooltip:
            "Enter the State, District, or Territory of the employer’s principal place of business.",
        },
        {
          machine_name: "poc_emp_zip",
          widget: "text",
          validate: [
            "required",
            {
              postalCountry: "poc_emp_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "poc_emp_country_id",
              },
            },
          ],
          maxLength: 10,
          label: "Postal code",
        },
        {
          machine_name: "poc_emp_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          tooltip:
            "Enter the province of the employer’s principal place of business, if applicable.",
        },
      ],
    },
    {
      name: "Point of Contact - Contact Information",
      fields: [
        {
          machine_name: "poc_emp_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          maxLength: 15,
          tooltip:
            "Enter the area code and telephone number for the employer’s principal place of business.",
        },
        {
          machine_name: "poc_emp_phone_ext",
          widget: "phone_ext",
          label: "Extension",
          validate: ["number"],
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number for the employer’s principal place of business, if applicable.",
        },
        {
          machine_name: "poc_emp_email",
          widget: "text",
          label: "Business Email Address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip:
            "Enter the email address for the employer’s principal place of business",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "poc_emp_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          validate: ["required"],
          maxLength: 50,
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
